import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { isMobile } from "react-device-detect"
import leftArrow from "@/public/icons/arrow-left.svg"
import rightArrow from "@/public/icons/arrow-right.svg"
import MissingImage from "@/public/images/image-missing.png"
import debounce from "lodash.debounce"
import VideoWrapper from "@/components/VideoWrapper/VideoWrapper"
import useWindowResize from "@/hooks/useWindowResize"
import { appendPresetToUrl } from "@/utils/helper"
import { getPresetThumbnailUrl } from "@/utils/index"

const ImageGalleryHorizontal = props => {
  let {
    productInfo,
    presetConfigObject = {},
    imageClickCounter,
    updateImageClickCounter,
    swatchUrl,
    assetAccountName
  } = props
  let imageListLength = props.data.length
  const [select, setSelected] = useState(0)
  const viewMoreLink = imageListLength > 10 ? true : false
  const imageList = props.isPopup ? props.data : props.data.slice(0, 10)
  const showArrowFlag = imageListLength > 20 && !isMobile ? true : false
  const showSliderArrow = imageListLength > 3 && !isMobile ? true : false
  const [width] = useWindowResize()
  let productDetailsForImage = props?.productDetailsForImage
  let resourceCredits =
    props &&
    props.productGalleryLabel &&
    props.productGalleryLabel.resourceCredit_s &&
    props.productGalleryLabel.resourceCredit_s.match("http") == null
      ? props.productGalleryLabel.resourceCredit_s
      : props.resourceCredits
      ? props.resourceCredits
      : ""

  const handleChange = (element, id, type, resourceCredits = "") => {
    const getOverAllImage = document.querySelectorAll(
      `#${props.galleryStackId}`
    )
    const defImageOffset = getOverAllImage[0].childNodes[0].offsetLeft
    const eleOffset = getOverAllImage[0].childNodes[element].offsetLeft
    const scrollValue = eleOffset - defImageOffset
    let isAlreadyChecked = false
    if (select === element) {
      isAlreadyChecked = true
    }
    slideView(scrollValue, element)
    if (window.adobeDataLayer && !isAlreadyChecked) {
      if (!id && imageList[element]) {
        // find matching if from imageList
        id = imageList[element].assetId || imageList[element].url
      }
      const { adobeDataLayer: { getState } = {} } = window
      const page = (getState && getState("page")) || {}
      const eventInfo = getEventInfo(type, id)
      const pI = productInfo ? JSON.parse(productInfo).productInfo : null
      window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: pI,
      })
      updateImageClickCounter && updateImageClickCounter()
    }

    let resourceCreditsTxt =
      resourceCredits && resourceCredits?.match("http") == null
        ? resourceCredits
        : ""
    const imageGalleryContainer =
      document.querySelector(".image-gallery-container") || null

    if (imageGalleryContainer) {
      const resourceCreditElement = imageGalleryContainer.querySelector(
        ".image-reel__photo-credit"
      )
      if (resourceCreditElement) {
        resourceCreditElement.innerHTML = resourceCreditsTxt
      }
    } else {
      const resourceCreditElement = document.querySelector(
        ".image-reel__photo-credit"
      )
      if (resourceCreditElement) {
        resourceCreditElement.innerHTML = resourceCreditsTxt
      }
    }
  }

  const getEventInfo = (type, id) => {
    const eventInfo = {
      eventAction: `pdp:modal:gallery:${type || "image or video"}`,
      eventName: `pdp:modal:gallery:${type || "image or video"}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: type || id,
      internalLinkPosition: "pdp",
      internalLinkType: `pdp:${type || "navigation"}`,
      internalLinkZoneName: "pdp:modal:gallery",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
    if (imageClickCounter && type !== "carousel") {
      eventInfo.imageSequence = imageClickCounter + 1
    }
    return eventInfo
  }

  function slideView(scrollValue, ele) {
    const getImageView = document.getElementById(`${props.galleryStackId}`)
    window.isCustomScroll = true
    getImageView.scrollTo({
      top: 0,
      left: `${scrollValue}`,
      behavior: "smooth",
    })
    setSelected(ele)
  }

  const onScroll = debounce(() => {
    if (!window.isCustomScroll) {
      const { adobeDataLayer: { getState } = {} } = window
      const page = (getState && getState("page")) || {}
      const eventInfo = getEventInfo("carousel")
      const pI = productInfo ? JSON.parse(productInfo).productInfo : null
      window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: pI,
      })
    } else {
      window.isCustomScroll = false
    }
  }, 2000)

  useEffect(() => {
    const getImageView = document.getElementById(`${props.galleryStackId}`)
    getImageView.removeEventListener("scroll", onScroll)
    getImageView.addEventListener("scroll", onScroll, { passive: true })
    return () => {
      delete window.isCustomScroll
      getImageView && getImageView.removeEventListener("scroll", onScroll)
    }
  }, [imageListLength])

  let pdpBadgeName = props?.productGalleryLabel?.isSale
    ? props?.staticTexts?.saleLabel
    : props?.productGalleryLabel?.newTag &&
      props?.productGalleryLabel?.productExclusive
    ? props?.staticTexts?.newLabel + "+" + props?.staticTexts?.exclusiveLebel
    : props?.productGalleryLabel?.newTag
    ? props?.staticTexts?.newLebel
    : props?.productGalleryLabel?.productExclusive
    ? props?.staticTexts?.exclusiveLebel
    : ""

  return (
    <React.Fragment>
      <div className="image-gallery">
        <div className="image-gallery__stack">
          {props?.showBadges && pdpBadgeName && (
            <div className="product-gallery__badge">
              <p className="product-gallery__new">{pdpBadgeName}</p>
            </div>
          )}
          <ul
            className="image-gallery__image-stack-view"
            id={props.galleryStackId}
          >
            {imageList.map((element, i) => {
              const imageData = element.url.split("/")
              const assetId = imageData[imageData.length - 1]
              return (
                <li id={i} key={i} className="image-gallery__image-stack-list">
                  {!element.type ? (
                    <img
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={appendPresetToUrl(
                        swatchUrl,
                        element.assetId ?? assetId,
                        width,
                        presetConfigObject,
                        props.isPopup,
                        props.accountName
                      )}
                      alt={element.label}
                      onClick={() => {
                        props?.enablePresets
                          ? handleChange(
                              i,
                              element.assetId || element.url,
                              "",
                              element?.resourceCredits
                            )
                          : handleChange(i, element.assetId || element.url)
                      }}
                      onKeyPress={event => {
                        if (event.key === "Enter")
                          props?.enablePresets
                            ? handleChange(
                                i,
                                element.assetId || element.url,
                                "",
                                element?.resourceCredits
                              )
                            : handleChange(i, element.assetId || element.url)
                      }}
                    />
                  ) : (
                    <VideoWrapper
                      height="100%"
                      videoId={element.url}
                      onClick={() => {
                        handleChange(i, element.url)
                      }}
                    />
                  )}
                </li>
              )
            })}
          </ul>
          {showSliderArrow && imageList.length > 1 && (
            <>
              <span
                className={
                  select === 0 ? "previous-image" : "previous-image-dark"
                }
                onClick={() => {
                  let pos = select > 0 ? select - 1 : select
                  handleChange(pos)
                }}
              ></span>
              <span
                className={
                  select === imageList.length - 1
                    ? "next-image"
                    : "next-image-dark"
                }
                onClick={() => {
                  let position =
                    imageList.length - 1 > select ? select + 1 : select
                  handleChange(position)
                }}
              ></span>
            </>
          )}
        </div>
        {productDetailsForImage && (<p className="image-reel__product-details">{productDetailsForImage}</p>)}
        {<p className="image-reel__photo-credit">{resourceCredits}</p>}
        <div className="image-gallery__thumb">
          {showArrowFlag && (
            <span>
              <img
                src={leftArrow}
                alt="leftArrow"
                className="image-gallery__left-arrow"
              />
            </span>
          )}
          <ul
            className="image-gallery__image-thumb-view"
            id="image-gallery__image-thumb-view"
          >
            {imageList.map((element, i) => (
              <li
                key={i}
                className="image-gallery__image-thumb-list"
                id="image-gallery__image-thumb-list"
              >
                <div
                  className={`image-gallery_${
                    select === i ? "_image-thumbSelected" : "_image-thumb"
                  }`}
                  onClick={() => {
                    props?.enablePresets
                      ? handleChange(
                          i,
                          element.assetId || element.url,
                          "",
                          element?.resourceCredits
                        )
                      : handleChange(i, element.assetId || element.url)
                  }}
                  onKeyPress={event => {
                    if (event.key === "Enter")
                      props?.enablePresets
                        ? handleChange(
                            i,
                            element.assetId || element.url,
                            "",
                            element?.resourceCredits
                          )
                        : handleChange(i, element.assetId || element.url)
                  }}
                >
                  {element.type ? (
                    <VideoWrapper thumb videoId={element.url} />
                  ) : (
                    <img
                      role="button"
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={
                        props?.enablePresets
                          ? element.url
                          : getPresetThumbnailUrl(
                              swatchUrl,
                              element.assetId,
                              presetConfigObject,
                              assetAccountName
                            )
                      }
                      alt={element.label}
                      tabIndex={0}
                    />
                  )}
                </div>
              </li>
            ))}

            {!props.isPopup && viewMoreLink && (
              <li className="image-gallery__image-thumb-list">
                <span
                  role="button"
                  tabIndex={0}
                  className="image-gallery__link-more viewmore-mobile"
                  onClick={() => props.handlePopup()}
                >
                  {props.staticTexts.viewMore}
                </span>
              </li>
            )}
          </ul>
          {showArrowFlag && (
            <span>
              <img
                src={rightArrow}
                alt="rightArrow"
                className="image-gallery__right-arrow"
              />
            </span>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

ImageGalleryHorizontal.defaultProps = {
  data: [],
  staticTexts: {},
  productInfo: "",
  imageClickCounter: 0,
}

ImageGalleryHorizontal.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  staticTexts: PropTypes.object,
  productInfo: PropTypes.string,
  imageClickCounter: PropTypes.number,
  updateImageClickCounter: PropTypes.func,
}

export default ImageGalleryHorizontal
